import { Collapse } from '@mui/material';
import classNames from 'classnames';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'src/app/hooks';
import { removeModal } from 'src/features/globalSlice';
import { removeCompany } from 'src/store/actions/companyActions';
import { Company } from 'src/store/models/Company';
import { Modal } from 'src/store/models/Modal';

import Button from '../Button/Button';
import LabelCheckbox from '../LabelCheckbox/LabelCheckbox';
import classes from './RemoveCompanyModal.module.scss';

export interface RemoveCompanyModalProps {
  modal?: Modal;
  className?: string;
}

const RemoveCompanyModal: FC<RemoveCompanyModalProps> = ({
  modal,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const company = modal?.data as Company;
  const numOfUsers = company?._count?.PortalUser;
  const title = company?.title;

  const [fullRemove, setFullRemove] = useState(false);

  return (
    <div className={classNames(classes.Container, className)}>
      <h4>{modal?.title}</h4>
      <div
        dangerouslySetInnerHTML={{
          __html: t(
            `service_account:${
              numOfUsers > 0
                ? 'company_will_be_removed_full'
                : 'company_will_be_removed'
            }`,
            { title }
          ),
        }}
      />
      {numOfUsers > 0 && (
        <section>
          <LabelCheckbox
            color="primary"
            label={t('service_account:delete_all_personnel', {
              service: company?._count?.PortalUser,
            })}
            className={classes.Checkbox}
            CheckboxProps={{
              value: fullRemove,
              onChange: (_, c) => setFullRemove(c),
            }}
          />
          <Collapse in={fullRemove}>
            <div
              dangerouslySetInnerHTML={{
                __html: t('service_account:full_remove_details'),
              }}
              className={classes.FullRemove}
            />
          </Collapse>
        </section>
      )}
      <footer>
        <Button
          className={classes.Secondary}
          onClick={() => {
            dispatch(removeModal());
          }}
          variant="outlined"
        >
          {t('common:cancel')}
        </Button>
        <Button
          className={classes.Primary}
          onClick={() =>
            dispatch(removeCompany({ company: company, fullRemove }))
          }
        >
          {t('common:confirm')}
        </Button>
      </footer>
    </div>
  );
};

export default RemoveCompanyModal;
